import React, { FC } from 'react';
import cn from 'clsx';

import AppLink from '../AppLink';
import LazyImage from '../LazyImage';
import LazyPicture from '../LazyPicture';
import LazyVideo from '../LazyVideo';
import SlatButton from '../SlatButton';

const COMPONENT_MAP: any = {
  title_1: ({ children, className }: any) => <h1 className={className}>{children}</h1>,
  title_2: ({ children, className }: any) => <h2 className={className}>{children}</h2>,
  title_3: ({ children, className }: any) => <h3 className={className}>{children}</h3>,
  p: ({ children, className }: any) => <p className={className}>{children}</p>,
  div: ({ children, className }: any) => <div className={className}>{children}</div>,
  span: ({ children, className }: any) => <span className={className}>{children}</span>,
  a: (props: any) => {
    return <AppLink {...props} />;
  },
  image: (props: any) => {
    return <LazyImage {...props} />;
  },
  picture: (props: any) => {
    return <LazyPicture {...props} />;
  },
  video: (props: any) => {
    return <LazyVideo {...props} />;
  },
  button: (props: any) => {
    return <SlatButton {...props} />;
  },
};

interface Props {
  className?: string;
  children?: any;
  content: any;
  tag: string;
  theme?: string;
}

const AutoSlat: FC<Props> = (props) => {
  const { children, className, content, tag, theme, ...additionalProps } = props;

  if (tag === 'components') {
    return content;
  }

  const ComponentType = COMPONENT_MAP[tag];

  const componentContent =
    children ||
    (content &&
      content.map &&
      content.map((props: any, index: number) => {
        return <AutoSlat key={index} {...props} />;
      }));

  if (ComponentType) {
    return (
      <ComponentType
        className={cn(className, theme ? `theme-${theme}-slat` : 'theme-default-slat')}
        {...additionalProps}
      >
        {componentContent}
      </ComponentType>
    );
  } else {
    console.error(`Component type "${tag}" not found.  Returning null`);
    return null;
  }
};

export default AutoSlat;
